import { getNumbersFromType } from "../functions/getNumbersFromType";
import { getFunctionsFromType } from "../functions/getFunctionsFromType";
import { getTypeFromFunctions } from "../functions/getTypeFromFunction";

class Type {
    constructor(_MBTI, isMBTI) {
      var a = getFunctionsFromType(_MBTI, isMBTI);
        this.dominantFunction = a[0];
        this.auxillaryFunction = a[1];
      this.mbti = isMBTI;
      var f = getNumbersFromType(_MBTI, isMBTI);
        this.firstFunction = f[0];
        this.secondFunction = f[1];
    }
    // Returns an int[2] with first two functions
    getSerialNumbers() {
      var a = [0, 0];
      a[0] = this.firstFunction;
      a[1] = this.secondFunction;
      return a;
    }
    // Return type as a string 
    toTypeCode() {
      return getTypeFromFunctions(this.dominantFunction, this.auxillaryFunction, this.mbti);
    }  
  }

  export {Type}